const Form069SC = {
    stepName: {
        statement: "陈述",
        information: "基本资料",
        certification: "丁部\n认证",
        confirmation: "确认",
        schoolInfo: "学校资料",
        SelectApplyType: "选择甲部／乙部／丙部",
        sectionA: "甲部\n暂时冻结因教师休假而出现的教学人员职位空缺",
        sectionB: "乙部\n暂时冻结在核准编制内的教学人员职位",
        sectionC: "丙部\n永久冻结常额职位",
    },
    title: {
        note: "注意",
        schoolInformation: "学校资料",
        secitonATitle: "甲部	暂时冻结因教师休假而出现的教学人员职位空缺",
        secitonBTitle: "乙部	暂时冻结在核准编制内的教学人员职位",
        secitonCTitle: "丙部  永久冻结常额职位（本申请表格须包括首次及先前冻结的所有职位，以查核10%的上限）",
        secitonCTitleB: "丙部  永久冻结常额职位", // Title
        secitonDTitle: "丁部  认证",
        teachersInformation: "休假教师资料",
        calculationInformation: "整合代课教师津贴计算数据",
        officialUse: "供部门填写",
        collectionStatement: "个人资料收集声明",
    },
    label: {
        absenceReasonOption: {
            optionA: "(a)	有薪病假/产假/肺病特别假期",
            optionB: "(b)	有薪进修假期",
            optionC: "(c)	给予教师有薪假期，以便出任陪审员或证人",
            optionD: "(d)	其他有薪假期(请说明原因)",
            optionF: "(x)	无薪病假/产假/肺病特别假期",
            optionG: "(y)	其他无薪假期",
        },
        leaveCalendarDaysOption: {
            thirty: "30 至 89 历日的假期",
            ninety: "90或以上历日的假期",
        },
        vacancyCalendarDaysOption: {
            thirty: "30 至 89 历日的假期",
            ninety: "90或以上历日的假期",
        },
        NAMOption: {
            N: "新申领津贴的职位",
            AM: "修订先前提出的申请（夹附副本）",
        },
        PRENEWOption: {
            PRE: "先前冻结的职位",
            NEW: "新冻结的职位",
        },
        surplusTeachersOption: {
            yes: "有过剩教师",
            no: "并没有过剩教师",
        },
        schoolName: "学校名称",
        schoolCode: "学校代码",
        name: "姓名",
        SRN: "职员参考编号",
        post: "职位",
        postNumber: "职位数量",
        absenceReason: "缺勤原因",
        paidLeaveReason: "其他带薪假期的原因",
        leavePeriodFrom: "休假时期由",
        leavePeriodTo: "休假时期至",
        periodFrom: "由",
        periodTo: "至",
        workingDays: "(a) 工作日数",
        dailyRate: "(b) 日薪率 $",
        monthsNo: "(c) 月份数目",
        monthlySalary: "(d) 月薪 $",
        MPFSubsidy: "(e) 强积金供款津贴 $",
        TRGAmount: "(f) 整合代课教师津贴额",
        TRGTotalAmount: "整合代课教师津贴额（总计）",
        postsClaimedNo: "申领津贴的职位数目",
        postsClaimedNoSectionC: "(a)申领津贴的职位数目",
        rank: "职级",
        NAM: "新申领津贴的职位／修订先前提出的申请（夹附副本）",
        attachment: "副本",
        PRENEW: "先前冻结的职位／新冻结的职位",
        Date: "先前提出申请的日期",
        effectiveDate: "生效日期",
        monthlyEffectiveDate:
            "(a) 生效日期计的每月中点薪金（只适用于新冻结职位)",
        frozenMPFSubsidy: "(b) 强积金供款津贴（只适用于新冻结职位)",
        frozenTRGAmount: "(c) 新冻结职位的整合代课教师津贴额",
        frozenPostsTotal: "休假教师",
        frozenPostsArising: "暂时冻结职位",
        approvedTeaching: "在核准编制内的教学人员职位",
        frozenRegularPosts: "永久冻结常额职位",
        total: "总计",
        surplusTeachers: "过剩教师",
        surplusTeachersNo: "过剩教师数量",
        contactPerson: "联络人",
        telNo: "电话号码",
        SSDO: "高级学校发展主任",
        required: "必须填写",
        select: "请选择你想要填写的部分：",
        supervisorName: "校监／校长姓名",
        mpfAttachment: "强积金供款副本",
        termsConditions: "本人已阅读「个人资料收集声明」及完全明白其内容。",
        iamStatement: "本人明白需透过「智方便+」帐户以辧理申请。",
    },
    message: {
        toMessage: "致: 教育局经常津贴组",
        attnMessage: "[经办人︰一级会计主任(经常津贴)]",
    },
    note: {
        importantNote1:
            "请提交电子表格或纸质表格，请注意，如果提交了重复的申请，处理过程可能会受影响",
        importantNote2:
            "如欲查询有关本表格所搜集的个人资料，包括要求查阅及改正资料事宜，需以书面方式向有关高级学校发展主任提出",
        importantNote3: "",
        note1: "1.	 请填写休假教师的教职员工参考编号",
        note2: "2.	 请填写以下缺席原因列表中的字母-",
        note3: "(a) 带薪病假/产假/特别结核病假；",
        note4: "(b) 带薪学习假；",
        note5: "(c) 为陪审员或证人服务的教师带薪休假；",
        note6: "(d) 其他带薪休假（请说明原因）；",
        note7: "(x) 无薪病假/产假/特别结核病假；",
        note8: "(y) 其他无薪假。",
        note9: "请注意，学校在放假时必须遵循教育局通告第 1／2006 号和第 16／2018 号。",
        note10: "3.	 工作日数不包括周日、周六（短周）、公众假期、酌情假期或任何教师无需履行职责的日子。",
        note11: "4.	 有关资助学校代课教师的现行每日工资标准，请参阅教育局相关通函。至于代课教师标准每日工资标准和各种冻结费用的实际数额，在按照公务员薪酬调整。",
        note12: "5.	 基本职级以临时教师的平均月薪点或晋升职级的起薪点。计算可选现金津贴的平均月薪点将每3年检讨一次，并在必要时进行修订。有关各职级的平均月薪点数，请参阅教育局网页的TRG指引 ",
        note12b:
            "http://www.edb.gov.hk/sc/sch-admin/fin-management/subsidy-info/trg/index.html",
        note12c: "。",
        note13: "6.	 冻结60个历日或以上的空缺教学职位，将包括雇主对强积金计划的供款（月薪的5%或$1,500，以较低者为准）。",
        note14: "7.	 冻结的教职不包括校长／班主任、英语母语教师、学生辅导教师、小学课程负责人、特殊教育需要协调员和特殊教育需要支持教师。",
        certificationNote1: "本人证实*–",
        certificationNote2:
            "本校的法团校董会已同意于上述学年期间冻结上述教职；",
        certificationNote3:
            "本校没有就上述乙部及丙部的职位空缺向教育局申领薪金津贴；",
        certificationNote4: {
            note1: "申领整合代课教师津贴的冻结职位总数",
            note2: "，包括(甲部)休假教师",
            note3: "和(乙部)在核准编制内的教学人员职位",
            note4: "的暂时冻结职位，以及(丙部)永久冻结常额职位",
            note5: "。这些冻结职位于申请当日并无超逾本校的核准教师编制总额(总数︰",
            note6: ") 10%的上限，",
            note7: "而",
            note8: "本申请亦符合整合代课教师津贴所订明的所有申请条件",
            note9: "(请于空位内填上职位数目)；",
        },
        certificationNote5: {
            note1: "本校",
            note2: "名，在暂时冻结因教师休假而出现的教学人员职位空缺前，过剩教师数目已经抵销；",
            note3: "，在暂时冻结因教师休假而出现的教学人员职位空缺前，过剩教师数目已经抵销；",
        },
        certificationNote6:
            "本校没有就上述假期/职缺/冻结职位期间向政府申请或领取其他额外津贴，例如以现金津贴取代额外英语教师职位及把小数位教师职位转为小数位职位现金津贴等；以及",
        certificationNote7:
            "除上述(iv)项有过剩教师的情况外，本校已冻结的教师职位总数和受聘的常额教师数目的总和在任何时段不会超逾已核准的教学人员编制。",
        certificationNote8: "本校会把教育局多付的津贴退还。",
        statementNote: {
            note1: "教育局会利用本表格所载的个人资料，作以下其中一种或多种用途︰",
            note2: "(a) 办理与聘用有关的事宜；",
            note3: "(b) 处理发放薪金津贴及其他政府资助；",
            note4: "(c) 计算公积金的供款；",
            note5: "(d) 进行核数工作；",
            note6: "(e) 进行研究及统计资料，以便规划教育服务；",
            note7: "(f) 处理有关教育专业人员发展的事宜；",
            note8: "(g) 执行相关《资助则例》、《教育条例》、《教育规例》及《补助/津贴学校公积金规则》的规定。",
            note9: "申请人必须在本表格上填写个人资料。申请人如不提供这些资料，申请的处理工作及结果或会受影响。",
            note10: "本表格所搜集的个人资料，或会向其他获授权的政府决策局/部门/机构披露作上述用途。",
            note11: "根据《个人资料(私隐)条例》，第18和22条及附表1保障资料第6原则的规定，你有权要求查阅及改正你的个人资料。要求查阅的权利，包括要求提供本表格所载个人资料的副本，但须缴付费用。",
            note12: "如欲查询有关本表格所搜集的个人资料，包括要求查阅及改正资料事宜，需以书面方式向有关高级学校发展主任提出。",
        },
    },
    order: ["(i)", "(ii)", "(iii)", "(iv)", "(v)", "(vi)"],
    tooltip: {
        tooltip1: "请填写休假教师的教职员工参考编号",
        tooltip2:
            "请注意︰学校必须按照教育局通告第1/2006号及第16/2018号的规定批核假期。",
        tooltip3:
            "工作日数不应包括星期日、星期六(短周)、公众假期、由学校自行订定的假期或教师毋须执行职务的任何周日。",
        tooltip4:
            "有关资助学校代课教师当时适用的日薪率，请参阅相关的教育局通函。代课教师标准日薪及用以冻结职位的各项津贴额的实际金额，会根据公务员薪酬调整。",
        tooltip5a:
            "基本职级以临时教师的平均每月薪点计算，晋升职级以该职级的起薪点计算。用以计算可供选择现金津贴的平均月薪点将每三年检讨一次，并在有需要时予以修订。相关职级的平均月薪点可参考在教育局网页内有关整合代课教师津贴的指引(网址为：",
        tooltip5b:
            "http://www.edb.gov.hk/sc/sch-admin/fin-management/subsidy-info/trg/index.html",
        tooltip5c: ")。",
        tooltip6:
            "如冻结出缺教职达60天或以上，将包括强积金计划雇主供款(月薪的5%或1,500元，取其较少者)。",
        tooltip7:
            "可冻结的教师职位不包括校长、以英语为母语的英语教师、学生辅导教师、小学课程统筹主任、特殊教育需要统筹主任及特殊教育需要支援老师职位。",
        tooltipCTitle:
            "本申请表格须包括首次及先前冻结的所有职位，以查核10%的上限",
        tooltipC1: "PRE: 先前冻结的职位 / NEW︰新冻结的职位",
        tooltipC2:
            "如冻结出缺教职达60天或以上，将包括强积金计划雇主供款(月薪的5%或1,500元，取其较少者)",
    },
    SSDOValue: {
        0: "北区",
        1: "葵青区",
        2: "西贡区",
        3: "东区",
        4: "屯门区",
        5: "九龙城区",
        6: "观塘区",
        7: "南区",
        8: "油尖旺区",
        9: "荃湾区",
        10: "沙田区",
        11: "深水埗区",
        12: "大埔区",
        13: "湾仔区",
        14: "离岛区",
        15: "中西区",
        16: "元朗区",
        17: "黄大仙区",
    },
    errorMsg: {
        least30Days: "时期少于30历日，请重新选择。",
        "E-001": "仅允许包含英文字符、空格、点、逗号、连字符和单引号。",
        "E-002": "請选择最少1项",
    },
};
export default Form069SC;
